[
	{ "pattern": "정육", "categoryId": "food-butcher", "priority": 120 },
	{ "pattern": "수산", "categoryId": "food-butcher", "priority": 120 },
	{ "pattern": "분식", "categoryId": "food-bunsik", "priority": 110 },
	{ "pattern": "국밥", "categoryId": "food-soup", "priority": 110 },
	{ "pattern": "곱창", "categoryId": "food-meat", "priority": 100 },
	{ "pattern": "고기", "categoryId": "food-meat", "priority": 100 },
	{ "pattern": "치과", "categoryId": "health-dental", "priority": 130 },
	{ "pattern": "약국", "categoryId": "health-pharmacy", "priority": 130 },
	{ "pattern": "의원", "categoryId": "health-clinic", "priority": 130 },
	{ "pattern": "한의원", "categoryId": "health-oriental", "priority": 130 },
	{ "pattern": "미용실", "categoryId": "beauty-hair", "priority": 100 },
	{ "pattern": "세탁", "categoryId": "daily-laundry", "priority": 100 },
	{ "pattern": "서점", "categoryId": "culture-book", "priority": 100 },
	{ "pattern": "주유", "categoryId": "transport-fuel", "priority": 100 },
	{ "pattern": "주차", "categoryId": "transport-parking", "priority": 100 },
	{ "pattern": "꽃집", "categoryId": "daily-flower", "priority": 100 },
	{ "pattern": "동물병원", "categoryId": "pet-hospital", "priority": 100 },
	{ "pattern": "카페", "categoryId": "food-cafe", "priority": 90 },
	{ "pattern": "베이커리", "categoryId": "food-bakery", "priority": 90 },
	{ "pattern": "편의점", "categoryId": "daily-cvs", "priority": 90 },
	{ "pattern": "이마트", "categoryId": "daily-hypermarket", "priority": 100 },
	{ "pattern": "홈플러스", "categoryId": "daily-hypermarket", "priority": 100 },
	{ "pattern": "롯데마트", "categoryId": "daily-hypermarket", "priority": 100 },
	{ "pattern": "코스트코", "categoryId": "daily-hypermarket", "priority": 100 },
	{ "pattern": "마트", "categoryId": "daily-supermarket", "priority": 80 },
	{ "pattern": "슈퍼", "categoryId": "daily-supermarket", "priority": 80 }
]
